module.exports = __webpack_public_path__ + "4c5811974b1760e2bc2c8097a4607bc7.png";